import { render, staticRenderFns } from "./MaterialPurchase.vue?vue&type=template&id=64030dbd&scoped=true&"
import script from "./MaterialPurchase.vue?vue&type=script&lang=js&"
export * from "./MaterialPurchase.vue?vue&type=script&lang=js&"
import style0 from "./MaterialPurchase.vue?vue&type=style&index=0&id=64030dbd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64030dbd",
  null
  
)

export default component.exports